/* global I18n, Routes */

import React, { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import withTranslation from 'react/helpers/i18n';
import PropTypes from 'prop-types';
import cookieUrl from 'placeholders/cookie.svg';

const cookieName = 'CookiesDisclaimerLMS';
const cookiesStatesKey = 'Dokeos::CookiesState';

function CookiesDisclaimer({ t, cookies_type = [] }) {
  const [isDisplayed, setIsDisplayed] = useState(false);
  const [acceptedCookie, setAcceptedCookie] = useState(null);
  const cookies = new Cookies();

  useEffect(() => {
    setAcceptedCookie(cookies.get(cookieName));
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDisplayed(true);
    }, 1000);

    if (!fetchCookiesState()) {
      setCookiesDefaultState();
    }

    return () => clearTimeout(timer);
  }, []);

  const cookiesRoute = Routes.cookies_path({ locale: I18n.locale });

  const acceptCookies = () => {
    cookies.set(cookieName, true, { path: '/', expires: new Date('12/31/2050') });
    closeCookies();
  };

  const closeCookies = () => {
    setIsDisplayed(false);
    setTimeout(() => {
      const cookiesEl = document.getElementById('cookies');
      if (cookiesEl) {
        cookiesEl.classList.add('pointer-events-none');
      }
    }, 0);
  };

  const fetchCookiesState = () => {
    return localStorage.getItem(cookiesStatesKey);
  };

  const setCookiesStateLocalStorage = (states) => {
    localStorage.setItem(cookiesStatesKey, JSON.stringify(states));
  };

  const setCookiesDefaultState = () => {
    let cookiesDefaultStates = {};
    cookies_type.map((type) =>
      type.cookies.map((cookie) => (
        cookiesDefaultStates[cookie.name] = cookie.default_value
      ))
    );
    setCookiesStateLocalStorage(cookiesDefaultStates);
  };

  return acceptedCookie ? null : (
    <div className={`cookie_inner ${isDisplayed ? '' : 'closed'}`}>
      <div className="cookies-disclaimer">
        <figure className="img-holder">
          <img src={cookieUrl} alt="cookie" />
        </figure>
        <p>
          {t('.message')}
          <a href={cookiesRoute} className="cookie-link">
            {t('.link')}
          </a>
        </p>
        <button
          className="button"
          onClick={acceptCookies}
          data-purpose="cookies_disclaimer_button"
        >
          {t('.accept')}
        </button>
        <span className="cookie-close" onClick={closeCookies}>
          <i className="material-icons">close</i>
        </span>
      </div>
    </div>
  );
}

CookiesDisclaimer.propTypes = {
  t: PropTypes.func.isRequired,
  cookies_type: PropTypes.array.isRequired,
};

export default withTranslation('js.components.cookies')(CookiesDisclaimer);